import {useQuery} from 'react-query';
import ClientsApiService from '@/services/ClientsApiService';

export const useGetClients = (filters, config = {}) => {
  filters.objectId = true;
  const {isLoading, isError, error, data} = useQuery(['search-clients', filters], async () => {
    const {data} = await ClientsApiService.getAllClients({size: 250, filters});
    return data;
  }, config);
  return {isLoading, isError, error, data};
};
